import type { IslandRenderer } from "./mount";
import type { LaboDraw } from "../components/labo/laboStats";
import { GenerateurIsland } from "../components/generateur/GenerateurIsland";

const draws = (props: unknown): LaboDraw[] => {
  const tirages = (props as { tirages?: unknown })?.tirages;
  return Array.isArray(tirages) ? (tirages as LaboDraw[]) : [];
};

/**
 * Clé = data-island de templates/pages/generateur-grille-keno.html.twig. Les fournisseurs
 * (React Query, AuthProvider) sont dans la partie chargée à la demande (GenerateurConnecte).
 */
export const GENERATEUR_ISLANDS: Record<string, IslandRenderer> = {
  generateur: (props) => <GenerateurIsland tiragesDesc={draws(props)} exemple={(props as { exemple?: unknown })?.exemple === true} />,
};
